import { render, staticRenderFns } from "./BankIdSign.vue?vue&type=template&id=1bf14e28&scoped=true&"
import script from "./BankIdSign.vue?vue&type=script&lang=js&"
export * from "./BankIdSign.vue?vue&type=script&lang=js&"
import style0 from "./BankIdSign.vue?vue&type=style&index=0&id=1bf14e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf14e28",
  null
  
)

export default component.exports